import React, { useEffect } from "react";

interface ToastProps {
  message: string | null;
  onDone: () => void;
  duration?: number;
}

// Small message pill shown above the footer; replaces browser alert() pop-ups.
const Toast: React.FC<ToastProps> = ({ message, onDone, duration = 2500 }) => {
  useEffect(() => {
    if (!message) return;
    const t = setTimeout(onDone, duration);
    return () => clearTimeout(t);
  }, [message, duration, onDone]);

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: "fixed",
        left: "50%",
        bottom: 80,
        transform: `translate(-50%, ${message ? 0 : 12}px)`,
        opacity: message ? 1 : 0,
        pointerEvents: "none",
        transition: "opacity 0.2s, transform 0.2s",
        background: "#1C1C1E",
        color: "#fff",
        padding: "12px 24px",
        borderRadius: 200,
        fontSize: 15,
        fontWeight: 500,
        boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
        zIndex: 3000,
        maxWidth: "calc(100vw - 32px)",
        textAlign: "center",
      }}
    >
      {message}
    </div>
  );
};

export default Toast;
